import React, { Fragment } from 'react'
import meetingPreview from 'images/meetingPreview.svg'

export default () =>
  <Fragment>
    <img src={meetingPreview} alt="meeting-preview" />
  </Fragment> 



// WEBPACK FOOTER //
// ./src/layouts/MeetingPreview/component.js